import type { Banner } from "@/types/media";

export const banners: Banner[] = [
  {
    id: "b1",
    mediaId: "1",
    title: "星际回声",
    subtitle: "年度硬核科幻巨制 · 宇宙尽头的归乡之旅",
    tag: "热映推荐",
    image: "https://readdy.ai/api/search-image?query=stylized%20cinematic%20space%20scene%2C%20vast%20deep%20orange%20and%20amber%20nebula%20with%20a%20lone%20spacecraft%20silhouette%20and%20glowing%20ring%2C%20dramatic%20dark%20composition%2C%20artistic%20film%20key%20art%2C%20no%20text&width=1920&height=1080&seq=hh-hero-01&orientation=landscape",
  },
  {
    id: "b2",
    mediaId: "24",
    title: "云上之城",
    subtitle: "东方奇幻新标杆 · 云海之上的失落文明",
    tag: "独家剧集",
    image: "https://readdy.ai/api/search-image?query=stylized%20epic%20chinese%20fantasy%20floating%20city%20above%20a%20sea%20of%20clouds%20at%20deep%20orange%20sunset%2C%20dramatic%20ink%20painting%20inspired%20key%20art%2C%20no%20text&width=1920&height=1080&seq=hh-hero-02&orientation=landscape",
  },
  {
    id: "b3",
    mediaId: "12",
    title: "少女与海",
    subtitle: "治愈系动画 · 海的尽头藏着最深的思念",
    tag: "口碑佳作",
    image: "https://readdy.ai/api/search-image?query=stylized%20anime%20art%20of%20a%20vast%20glowing%20orange%20sea%20at%20sunset%20with%20distant%20cliffs%20and%20soft%20clouds%2C%20dreamy%20painterly%20key%20art%2C%20no%20text&width=1920&height=1080&seq=hh-hero-03&orientation=landscape",
  },
  {
    id: "b4",
    mediaId: "15",
    title: "时间褶皱",
    subtitle: "烧脑神作 · 如果可以重新选择一次",
    tag: "编辑力荐",
    image: "https://readdy.ai/api/search-image?query=stylized%20surreal%20cinematic%20corridor%20warping%20into%20a%20spiral%20of%20warm%20orange%20light%2C%20dreamlike%20abstract%20key%20art%2C%20no%20text&width=1920&height=1080&seq=hh-hero-04&orientation=landscape",
  },
];

export const categoryList = [
  {
    key: "movie",
    name: "电影",
    en: "Movies",
    icon: "ri-film-line",
    description:
      "汇聚全球院线新片、口碑佳作与独立电影，涵盖科幻、悬疑、剧情、动作等多元类型，帮你快速找到下一部值得一看的电影。",
  },
  {
    key: "tv",
    name: "电视剧",
    en: "TV Series",
    icon: "ri-tv-2-line",
    description:
      "精选各地热播剧集与口碑佳作，涵盖都市、刑侦、奇幻、历史等题材，追剧不再迷路，每一部都值得投入时间。",
  },
  {
    key: "sci-fi",
    name: "科幻",
    en: "Sci-Fi",
    icon: "ri-rocket-2-line",
    description:
      "硬核设定与天马行空的想象，带你遨游星际、穿梭时空，探索科技与人性的边界。",
  },
  {
    key: "suspense",
    name: "悬疑",
    en: "Suspense",
    icon: "ri-search-eye-line",
    description:
      "层层反转、步步惊心，从罪案侦查到心理博弈，让你一次看个过瘾。",
  },
  {
    key: "drama",
    name: "剧情",
    en: "Drama",
    icon: "ri-book-open-line",
    description:
      "扎根现实、观照人心，那些关于家庭、成长与选择的动人故事。",
  },
  {
    key: "fantasy",
    name: "奇幻",
    en: "Fantasy",
    icon: "ri-magic-line",
    description:
      "瑰丽世界与东方美学，走进想象力构筑的奇境，感受不一样的风景。",
  },
];